export default __webpack_public_path__ + "img/bzNXKOFJ.ae6ce6d6.svg";